import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Mail, Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { fileUrl, buildWaLink, LOGO, safeUrl } from "@/lib/api";

export function Footer() {
  const { settings } = useSettings();
  const cats = [
    { label: "Trips", to: "/trips?category=trips" },
    { label: "Treks", to: "/trips?category=treks" },
    { label: "Dham Yatras", to: "/trips?category=dham-yatras" },
    { label: "Weekend Getaways", to: "/trips?category=weekend-getaways" },
    { label: "Adventure", to: "/trips?category=adventure" },
  ];
  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="mx-auto max-w-7xl px-6 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Link to="/" className="inline-block" data-testid="footer-logo">
            <img src={fileUrl(settings.logo_url) || LOGO} alt={settings.brand_name || "Safarshala"} className="h-16 w-auto object-contain footer-logo-glow" />
          </Link>
          <p className="mt-4 text-sm text-secondary-foreground/70 max-w-xs">{settings.tagline || "Journeys that stay with you."} {settings.about?.slice(0, 90)}</p>
          <div className="mt-5 flex gap-3">
            {safeUrl(settings.instagram) && <a href={safeUrl(settings.instagram)} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-gold transition-colors"><Instagram className="h-5 w-5" /></a>}
            {safeUrl(settings.facebook) && <a href={safeUrl(settings.facebook)} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-gold transition-colors"><Facebook className="h-5 w-5" /></a>}
            {settings.whatsapp_number && <a href={buildWaLink(settings.whatsapp_number, "Hi Safarshala!")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-[#25D366] transition-colors"><MessageCircle className="h-5 w-5" /></a>}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-xl mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-secondary-foreground/70">
            <li><Link to="/trips" className="hover:text-gold">All Trips</Link></li>
            <li><Link to="/calendar" className="hover:text-gold">Upcoming Departures</Link></li>
            <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            <li><Link to="/partner" className="hover:text-gold" data-testid="footer-partner">Partner with us</Link></li>
            <li><Link to="/admin/login" className="hover:text-gold">Admin Portal</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-xl mb-4">Categories</h4>
          <ul className="space-y-2 text-sm text-secondary-foreground/70">
            {cats.map((c) => <li key={c.label}><Link to={c.to} className="hover:text-gold">{c.label}</Link></li>)}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-xl mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm text-secondary-foreground/70">
            {settings.contact_number && <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> {settings.contact_number}</li>}
            {settings.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> {settings.email}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-foreground/60">
          <p>© {new Date().getFullYear()} {settings.brand_name || "Safarshala"}. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/policies#terms" className="hover:text-gold">Terms & Conditions</Link>
            <Link to="/policies#privacy" className="hover:text-gold">Privacy Policy</Link>
            <Link to="/policies#refund" className="hover:text-gold">Cancellation / Refund</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
